import getAgeByBirthdayDate from 'common/utils/getAgeByBirthdayDate'
import Heading from 'presentation/shared/components/Heading'
import TextField from 'presentation/shared/components/TextField'
import {
  phoneMask,
  dateMask,
  landlinePhoneMask
} from 'presentation/utils/masks'
import React from 'react'
import * as S from '../styles'
import SelectField from 'presentation/shared/components/SelectField'
import { gender } from 'common/enum/gender'
import { useFormikContext } from 'formik'
import { AmbulatoryScheduleDetailsEditFormikValues } from 'presentation/hospital/layouts/AmbulatoryScheduleDetails/types'
import { ReactComponent as EditIcon } from 'presentation/assets/icons/edit.svg'

export function AmbulatorySchedulePatientInfo({
  allowEdit
}: {
  allowEdit?: boolean
}) {
  const { values, handleChange, errors, setFieldValue } =
    useFormikContext<AmbulatoryScheduleDetailsEditFormikValues>()

  const defaultTextFieldProps = {
    placeholder: values?.isEditing ? 'Digite aqui...' : '-',
    disabled: !values?.isEditing,
    autoComplete: 'off'
  }

  return (
    <>
      <S.HeadingWrapper>
        <Heading size="large" color="primary">
          Dados do Paciente
        </Heading>
        {allowEdit && (
          <S.Edit
            data-testid="ambulatorySchedulePatientEditButton"
            onClick={() =>
              !values?.isEditing && setFieldValue('isEditing', true)
            }
          >
            <EditIcon /> Editar
          </S.Edit>
        )}
      </S.HeadingWrapper>

      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField
            label="Paciente"
            {...defaultTextFieldProps}
            data-testid="ambulatorySchedulePatientName"
            name={'updatePatient.name'}
            onChange={handleChange}
            value={values?.updatePatient?.name}
            error={values?.isEditing && errors?.updatePatient?.name}
            required
          />
        </div>
        <div style={{ maxWidth: '200px' }}>
          <TextField
            {...defaultTextFieldProps}
            data-testid="ambulatorySchedulePatientBirthday"
            name={'updatePatient.birthday'}
            onChange={handleChange}
            value={values?.updatePatient?.birthday || ''}
            placeholder="__/__/____"
            label="Data de nascimento"
            mask={dateMask}
            error={values?.isEditing && errors?.updatePatient?.birthday}
            required
          />
        </div>
        <div style={{ maxWidth: '100px' }}>
          <TextField
            label="Idade"
            disabled
            value={getAgeByBirthdayDate(values?.updatePatient?.birthday)}
          />
        </div>
      </S.Form>

      <S.Form>
        <div style={{ maxWidth: '160px' }}>
          <SelectField
            label="Sexo"
            name={'updatePatient.gender'}
            id="gender"
            value={values?.updatePatient?.gender || ''}
            {...defaultTextFieldProps}
            data-testid="ambulatorySchedulePatientGender"
            onChange={handleChange}
            items={gender}
            error={values?.isEditing && errors?.updatePatient?.gender}
            required
          />
        </div>
        <div style={{ maxWidth: '160px' }}>
          <TextField
            label="CPF"
            disabled
            value={values?.updatePatient?.cpf}
            required
          />
        </div>
      </S.Form>
      <S.Form>
        <div style={{ maxWidth: '200px' }}>
          <TextField
            label="Celular"
            {...defaultTextFieldProps}
            data-testid="ambulatorySchedulePatientPhone"
            name={'updatePatient.phone'}
            onChange={handleChange}
            value={values?.updatePatient?.phone || ''}
            error={values?.isEditing && errors?.updatePatient?.phone}
            mask={phoneMask}
          />
        </div>
        <div style={{ maxWidth: '180px' }}>
          <TextField
            label="Telefone"
            {...defaultTextFieldProps}
            data-testid="ambulatorySchedulePatientLandlinePhone"
            name={'updatePatient.landlinePhone'}
            onChange={handleChange}
            value={values?.updatePatient?.landlinePhone || ''}
            error={values?.isEditing && errors?.updatePatient?.landlinePhone}
            mask={landlinePhoneMask}
          />
        </div>
        <div style={{ maxWidth: '287px' }}>
          <TextField
            label="E-mail"
            name={'updatePatient.email'}
            onChange={handleChange}
            data-testid="ambulatorySchedulePatientEmail"
            {...defaultTextFieldProps}
            value={values?.updatePatient?.email}
            error={values?.isEditing && errors?.updatePatient?.email}
          />
        </div>
      </S.Form>
    </>
  )
}
